'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//职责链构造函数
var DutyChainPattern = function DutyChainPattern(fn) {
  this.queue = [];
  //注册职责链
  this.$add(fn);
};
DutyChainPattern.prototype = {
  constructor: DutyChainPattern,
  //忽略数组形式，保持职责单一，此处保留数组形式
  $add: function $add(fn) {
    this.queue.push(fn);
  },
  setNext: function setNext(patternInstance) {
    if (!(patternInstance instanceof DutyChainPattern)) {
      this.console('error', 'param must be DutyChainPattern instance');
      return false;
    }
    this.nextInstance = patternInstance;
  },
  exec: function exec() {
    var _this = this,
        _arguments = arguments;

    return _promise2.default.resolve().then(function (res) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(_this.queue), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          //执行职责链中回调
          var _res = item && item.apply(_this, _arguments);
          //判断职责是否匹配,next为不匹配
          if (typeof _res === 'string' && _res === 'next') {
            return _this.nextInstance && _this.nextInstance.exec.apply(_this.nextInstance, _arguments);
          } else if ((typeof _res === 'undefined' ? 'undefined' : (0, _typeof3.default)(_res)) === 'object' && typeof _res.then === 'function') {
            //判断返回值是否为Promise，考虑兼容性，暂不做native Promise判断
            //根据Promise A+规范，暂只判断then方法
            return _res.then(function ($res) {
              if (typeof $res === 'string' && $res === 'next') {
                return _this.nextInstance && _this.nextInstance.exec.apply(_this.nextInstance, _arguments);
              }
              return $res;
            });
          } else {
            //返回成功结果
            return _res;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });
  }
};
exports.default = DutyChainPattern;